module.exports = __webpack_public_path__ + "cf.9029cb92274f2bdd7b8c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cf.svg
// module chunks = styles